export default __webpack_public_path__ + "static/media/icon_phone.4c372981.svg";